import * as axios from './Axios'

const PREFIX = 'order'

export const _timeline = data => axios.get(`${PREFIX}/${data}/status/timeline`)

export const _status_list = () => axios.get(`admin/${PREFIX}/status/list`);
